module.exports = __webpack_public_path__ + "a1935f207416c7ed14d9b54e1af40c7e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ic_instagram.svg
// module id = Ncae
// module chunks = 5